import { type BasePoint, Path } from 'slate';

export default function sortSelection({ anchor, focus }: TSortSelectionRange): [BasePoint, BasePoint] {
    if (Path.isBefore(anchor.path, focus.path)) {
        return [anchor, focus];
    }
    if (Path.isAfter(anchor.path, focus.path)) {
        return [focus, anchor];
    }
    return anchor.offset < focus.offset ? [anchor, focus] : [focus, anchor];
}

// #region Types

export type TSortSelectionRange = {
    anchor: BasePoint;
    focus: BasePoint;
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('sortSelection', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
